<template>
  <div class="homeWrap">
    欢迎进入乔司时尚地图管理后台
   <!-- <div class="areaBlock">
      <div class="areaTitle">总计概况</div>
      <div class="areaContent flexWrap">
        <div class="smallBlock">
          <div class="leftBlock">
            <div class="smallTitle">单位(家)</div>
            <div class="smallTitle_sub">参加活动商户总数</div>
          </div>
          <div class="rightBlock">
            <span class="blueNum">100</span>
          </div>
        </div>
        <div class="smallBlock">
          <div class="leftBlock">
            <div class="smallTitle">单位(个)</div>
            <div class="smallTitle_sub">领取红包总个数</div>
          </div>
          <div class="rightBlock">
            <span class="blueNum">100</span>
          </div>
        </div>
        <div class="smallBlock">
          <div class="leftBlock">
            <div class="smallTitle">单位(个)</div>
            <div class="smallTitle_sub">商家已核销红包总数</div>
          </div>
          <div class="rightBlock">
            <span class="blueNum">100</span>
          </div>
        </div>
        <div class="smallBlock ">
          <div class="leftBlock width100">
            <div class="smallTitle">红包使用转化率</div>
            <div class="smallTitle_sub">
              <el-progress :percentage="50"></el-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="areaBlock">
      <div class="areaTitle">今日概况</div>
      <div class="areaContent">
        <div class="desLine">
          <div class="oneDes">
            <div class="title">登录用户数</div>
            <div class="num">4677</div>
            <div class="imgBox">
              <img src="../../assets/images/pic/img_dengluyonghushu.png" alt="">
            </div>
          </div>
          <div class="oneDes">
            <div class="title">领取红包数</div>
            <div class="num">3621</div>
            <div class="imgBox">
              <img src="../../assets/images/pic/img_lingquhongbaoshu.png" alt="">
            </div>
          </div>
          <div class="oneDes">
            <div class="title">商家核销红包数</div>
            <div class="num">4690</div>
            <div class="imgBox">
              <img src="../../assets/images/pic/img_shangjiahexiaohongbaoshu.png" alt="">
            </div>
          </div>
          <div class="oneDes">
            <div class="title">红包转化率</div>
            <div class="num">
              <el-progress type="circle" :percentage="25" :width="90"></el-progress>
            </div>
          </div>
        </div>
        <div class="echartTitle">每日领卷详情</div>
        <div class="canvasBox" id="echartBox_juan" :style="{width:'100%',height:canvasHeight+'px'}"> </div>
      </div>
    </div>
    <div class="areaBlock">
      <div class="areaTitle">趋势图</div>
      <div class="areaContent">
        <div class="btnOptionBox">
          <el-button type="primary" plain size="mini">浏览量(PV)</el-button>
          <el-button type="primary" plain size="mini">访客数(UV)</el-button>
          <el-select placeholder="其他" v-model="trendOption" size="mini" >
              <el-option   label="选项一" value="1"></el-option>
              <el-option   label="选项二" value="2"></el-option>
            </el-select>
        </div>
        <div class="canvasBox" id="echartBox_trend" :style="{width:'100%',height:canvasHeight+'px'}"> </div>
      </div>
    </div> -->

  </div>
</template>

<script>
  // import {json,wordData,utils} from '@/common/common.js'
  import echarts from 'echarts'
  import {
    api,
    ajaxPost
  } from '@/common/request.js'
  export default {
    name: 'HelloWorld',
    data() {
      return {
        canvasHeight: 300,
        aris_date_juan: ['1月1日', '1月2日', '1月3日', '1月4日', '1月5日', '1月1日', '1月2日', '1月3日', '1月4日', '1月5日'],
        aris_num_juan: [100, 200, 70, 400, 100, 100, 200, 100, 300, 100],
        trendOption:''
      }
    },
    methods: {
      drawPie_juan() {
        let _this = this
        let charts = echarts.init(document.getElementById('echartBox_juan'))
        let xData = _this.xData
        let option = {
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            data: ['01/01', '01/02', '01/03', '01/04', '01/05', '01/06', '01/07','01/08','01/09','01/10']
          }],
          yAxis: [{
            type: 'value',
            // splitLine: {show: false}
          }],
          series: [{
              type: 'line',
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              },
              data: [120, 132,196, 122,82, 230, 210,99,102,123,111,80],
              itemStyle : {
                normal : {
                    color:'#5CAFFF', //改变折线点的颜色
                }
              }
            },
          ]
        };
        charts.setOption(option)
      },
      drawPie_trend() {
        let _this = this
        let charts = echarts.init(document.getElementById('echartBox_trend'))
        let xData = _this.xData
        let option = {
          tooltip: {
            // trigger: 'axis',
          },
          legend: {
            data: ['昨日', '上周同期'],
            align: 'right',
            right:100
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          }],
          yAxis: [{
            type: 'value',
            // splitLine: {show: false}
          }],
          series: [{
              name: '昨日',
              type: 'line',
              stack: '总量',
              areaStyle: {},
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              },
              data: [120, 132,231, 122,12, 230, 210],
              itemStyle : {
                normal : {
                    color:'#5CAFFF', //改变折线点的颜色
                    lineStyle:{
                      color:'#5CAFFF' //改变折线颜色 #7C6AF2
                    }

                }
              }
            },
            {
              name: '上周同期',
              type: 'line',
              stack: '总量',
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              },
              areaStyle: {
                normal: {}
              },
              data: [130, 112, 131,66, 232, 123, 222],
              itemStyle : {
                normal : {
                    color:'#7C6AF2', //改变折线点的颜色
                    lineStyle:{
                      color:'#7C6AF2' //改变折线颜色 #7C6AF2
                    }

                }
              }

            }
          ]
        };
        charts.setOption(option)
      },
    },
    mounted() {
      this.drawPie_juan()
      this.drawPie_trend()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  // *{outline: 1px solid blue;}
  .homeWrap {
    padding:20px;
    // .canvasBox{
    //   padding-left:0.5rem;
    // }
    .echartTitle{font-weight: bold;margin-top:10px;font-size: 16px;}
    .blueNum {
      color: #5584FF;
      font-size: 25px;
      line-height: 50px;
      padding-left:40px;

    }

    .areaBlock {
      background: #fff;
      margin-bottom: 20px;
      border-radius: 6px;

      .areaTitle {
        font-size: 20px;
        color: #000000;
        padding:25px 30px ;
      }

      .areaContent {
        padding: 0 35px;
        padding-bottom: 25px;
      }
    }

    .flexWrap {
      display: flex;

      .smallBlock {
        flex: 1;
        display: flex;
        border-right: 1px solid #E6E7EB;
        height:50px;

        .leftBlock {
          padding-left:50px;

          .smallTitle {
            font-size: 12px;
            padding-bottom:10px;
            ;
          }

          .smallTitle_sub {
            font-size: 12px;
            color: #999;
          }
        }

        .leftBlock.width100 {
          flex: 1
        }

        .rightBlock {}
      }

      .smallBlock:last-child {
        border-right: 0;
      }

      .smallBlock:first-child .leftBlock {
        padding-left: 0;
      }
    }

    .desLine {
      display: flex;

      .oneDes {
        flex: 1;
        text-align: center;

        .title {
          font-size:12px;
          color: #666;
        }

        .num {
          font-size: 32px;
          margin: 10px 0;
        }

        .imgBox img {
          width:50px;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue